if (!customElements.get('sticky-cart-bar')) {
  customElements.define(
    'sticky-cart-bar',
    class StickyCartBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.section;

        // Find main product buy button (not the sticky bar's own button)
        const mainProductInfo = document.querySelector(`product-info[data-section="${this.sectionId}"]`);
        this.buyButton = mainProductInfo?.querySelector('.product-form__submit');

        if (!this.buyButton) return;

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler);

        // Subscribe to variant changes to update the hidden input and price
        if (window.subscribe) {
          this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
          this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
        }

        // Initial check
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.variantUnsubscribe) this.variantUnsubscribe();
        if (this.cartUnsubscribe) this.cartUnsubscribe();
      }

      onScroll() {
        const buttonBottom = this.buyButton.getBoundingClientRect().bottom;

        // Show sticky bar when buy button scrolls out of view
        if (buttonBottom < 0) {
          this.classList.add('active');
          this.classList.remove('hidden');
        } else {
          this.classList.remove('active');
        }
      }

      onVariantChange({ data: { sectionId, html, variant } }) {
        // Only respond to variant changes from our section
        if (sectionId !== this.sectionId) return;

        this.updateVariant(variant, html);
      }

      onCartUpdate() {
        // Hide sticky bar immediately when item added to cart
        this.classList.remove('active');
        this.classList.add('hidden');
      }

      updateVariant(variant, html) {
        if (!variant) return;

        // Update variant ID in form
        const input = this.querySelector('input[name="id"]');
        if (input) input.value = variant.id;

        // Update price from the fetched HTML (already contains updated price)
        const stickyPrice = this.querySelector(`#StickyPrice-${this.sectionId}`);
        if (stickyPrice && html) {
          const newPrice = html.getElementById(`price-${this.sectionId}`);
          if (newPrice) {
            stickyPrice.innerHTML = newPrice.innerHTML;
          }
        }

        // Update button state
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton) {
          if (!variant.available) {
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.querySelector('span').textContent = window.variantStrings?.soldOut || 'Sold out';
          } else {
            submitButton.removeAttribute('disabled');
            submitButton.querySelector('span').textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }
    }
  );
}
